/** Spanish – add or override keys; missing keys fall back to English (en.js). */
export default {
  'nav.home': 'Inicio',
  'nav.seeDemo': 'Ver demo',
  'nav.howItWorks': 'Cómo funciona',
  'nav.pricing': 'Precios',
  'nav.aboutUs': 'Nosotros',
  'nav.faqs': 'Preguntas frecuentes',
  'nav.contact': 'Contacto',
  'nav.blog': 'Blog',
  'nav.logIn': 'Iniciar sesión / Registrarse',
  'nav.getStarted': 'Comenzar',
  'brand.primeDocumentSign': 'Prime Document Sign',
  'hero.priceBanner': '¡Desde solo $2 al mes!',
  'hero.oneAgreement': '¿Solo 1 acuerdo por firmar? Solo 6 $ con funciones Premium – sin suscripción.',
  'hero.subscriptionsOnly': '( Solo suscripciones )',
  'hero.couponBannerText': '¡Código de cupón 10 % de descuento de por vida para nuestros primeros 1000 usuarios!',
  'hero.couponSubscribedOnly': '(solo suscriptores)',
  'hero.couponCode': '25OFFNEWUSERS1000',
  'hero.bannerEyebrow': 'Plataforma de firma electrónica · Planes desde $2/mes',
  'hero.bannerHeadlinePrefix': 'Consiga',
  'hero.bannerHeadlineMid': 'firmados',
  'hero.bannerHeadlineAccent': 'al instante.',
  'hero.bannerCycleContracts': 'Contratos',
  'hero.bannerCycleNDAs': 'NDAs',
  'hero.bannerCycleProposals': 'Propuestas',
  'hero.bannerCycleDocuments': 'Documentos',
  'hero.bannerDesc':
    'Cree acuerdos profesionales, envíelos para firma electrónica y reciba PDF firmados legalmente válidos — en minutos, desde cualquier dispositivo.',
  'hero.firebaseTopAria': 'Seguridad y alojamiento (Google Firebase y Google Cloud)',
  'hero.topTrustListAria': 'Seguridad, precios, firma, recordatorios y soporte',
  'hero.accDataSafeTitle': 'Sus datos están seguros con nosotros',
  'hero.accDataSafe1':
    'Impulsado por Google Firebase y Google Cloud: infrastructures de nivel empresarial en las que confían millones de aplicaciones',
  'hero.accDataSafe2':
    'Sus datos están protegidos con cifrado AES-256 en reposo con claves gestionadas por Google',
  'hero.accDataSafe3':
    'Autenticación y manejo de datos basados en los estándares de seguridad líderes de Google',
  'hero.accDataSafe4': 'Nunca vendemos ni compartimos sus datos; su privacidad se respeta siempre',
  'hero.accDataSafe5Before': 'Transparencia total sobre el almacenamiento y uso de sus datos (consulte nuestra ',
  'hero.accDataSafe5After': ')',
  'hero.accPricingTitle': 'Precios simples y asequibles — sin cargos ocultos',
  'hero.accPricing1': 'Cree acuerdos profesionales en minutos',
  'hero.accPricing2': 'Planes desde solo $2 al mes',
  'hero.accPricing3': 'Sin cargos ocultos ni sorpresas',
  'hero.accPricing4': 'Sin permanencia — cancele cuando quiera',
  'hero.accPricing5': 'Ideal para autónomos, startups y pequeñas empresas',
  'hero.accPricing6': 'Envíe su primer documento gratis para empezar',
  'hero.accSigningTitle': 'Firma de documentos rápida y sencilla',
  'hero.accSigning1': 'Elija entre más de 30 plantillas listas o suba la suya',
  'hero.accSigning2': 'Añada campos de firma y personalice el documento en segundos',
  'hero.accSigning3': 'Envíe a varios destinatarios a la vez',
  'hero.accSigning4': 'Guarde plantillas para reutilizarlas',
  'hero.accSigning5': 'Los firmantes no necesitan cuenta — pueden firmar al instante',
  'hero.accSigning6': 'Vista previa en vivo para asegurar que todo queda perfecto antes de enviar',
  'hero.accRemindersTitle': 'Recordatorios inteligentes y seguimiento',
  'hero.accReminders1': 'Recordatorios automáticos a los 1, 3 y 7 días',
  'hero.accReminders2': 'Reciba avisos al abrir o firmar un documento',
  'hero.accReminders3': 'Siga todo el proceso de firma en tiempo real',
  'hero.accReminders4': 'Deje de reclamar firmas a mano',
  'hero.accAnywhereTitle': 'Trabaje desde cualquier lugar',
  'hero.accAnywhere1': 'Acceda a sus documentos en escritorio o móvil',
  'hero.accAnywhere2': 'Envíe y firme desde cualquier dispositivo',
  'hero.accAnywhere3': 'Diseñado para la flexibilidad — oficina o en movimiento',
  'hero.accSupportTitle': 'Soporte confiable',
  'hero.accSupport1': 'Atención al cliente dedicada con respuestas rápidas',
  'hero.accSupport2': 'Objetivo: responder en 24 horas',
  'hero.accSupport3': 'Mejoras continuas basadas en la opinión de los usuarios',
  'hero.firebaseTrustPrivacyLink': 'Política de privacidad',
  'hero.firebaseTrustFineprintAfter':
    ' explica la retención de datos, el acceso y sus derechos. Nunca vendemos sus datos.',
  'hero.pill': 'Envíe firmas electrónicas legalmente vinculantes en segundos',
  'hero.headline': 'La herramienta de firma electrónica más simple para freelancers y equipos pequeños',
  'hero.watchDemo': 'Ver demo',
  'hero.trustLocked': 'Cifrado AES-256',
  'hero.trustNoCard': 'Sin tarjeta',
  'hero.trustReady': 'Listo en 2 min',
  'hero.landingShowMore': 'Mostrar más',
  'hero.landingShowLess': 'Mostrar menos',
  'hero.tagline': 'La forma más fácil de crear, firmar y enviar documentos — sin permanencia',
  'hero.ctaPrimary': 'Crear / Subir documento y enviar para firma',
  'hero.ctaTrialSignup': 'Prueba ahora con 1 mes de prueba gratuita',
  'hero.ctaFreeDocument': 'Prueba un documento gratis ahora',
  'hero.ctaPrimaryNote': 'No se requiere tarjeta ni datos de pago.',
  'hero.subscriptionTeaserBefore': 'Suscripciones desde solo ',
  'hero.subscriptionTeaserAfter': ' al mes!',
  'hero.createAccountTrialHeadline': 'Regístrate ahora y obtén 1 mes de prueba gratis',
  'hero.createAccountPromoCopy': 'Copiar código',
  'hero.createAccountPromoCopied': '¡Copiado!',
  'hero.createAccountPromoCodeAria': 'Código promocional: un mes de prueba gratis',
  'hero.createAccountNote': 'Úsalo al pagar cuando elijas un plan.',
  'hero.createAccountOfferLimit': '( Oferta válida solo para nuestros primeros 1000 usuarios )',
  'hero.desc': 'Ayuda a personas y equipos a crear, enviar y hacer seguimiento de acuerdos con una experiencia de firma moderna.',
  'hero.getStartedFree': 'Comenzar gratis',
  'hero.tryWithoutAccountButton': 'Probar sin cuenta',
  'hero.logInSignUp': 'Iniciar sesión / Registrarse',
  'hero.whyChooseUs': '¿Por qué elegirnos?',
  'hero.stepsTitle': 'Crear, Firmar, Recibir',
  'hero.stepsSubtitle': 'Tres pasos simples para crear y firmar documentos en minutos.',
  'hero.step1Create': 'Sube o crea tu documento',
  'hero.step2Sign': 'Envíalo para firma',
  'hero.step3Receive': 'Recibe una notificación al instante cuando se firme',
  'hero.benefit1': 'Fácil de usar – Envía enlaces y correos de firma en segundos',
  'hero.benefit2': 'Sube PDF existente o extrae texto y edita con el editor de texto enriquecido',
  'hero.benefit3': 'Extrae texto del PDF y edita',
  'hero.benefit4': 'Crea campos de firma y diseños en segundos',
  'hero.benefit5': 'Envía a varios destinatarios a la vez',
  'hero.benefit6': 'Sin suscripción – pago único por envío',
  'hero.benefit7': 'Copia el enlace y envíalo a quien quieras',
  'hero.benefit8': 'Crea y guarda plantillas',
  'hero.benefit9': 'Consulta todos los eventos de correo',
  'hero.benefit10': 'Vista previa en vivo y PDFs listos para auditoría',
  'hero.benefit11': 'Plantillas con edición flexible',
  'hero.benefit12': 'Los destinatarios no necesitan registrarse',
  'hero.benefit13': 'Funciona en cualquier dispositivo',
  'how.simpleProcess': 'Proceso simple',
  'how.title': 'Cómo funciona',
  'how.subtitle': 'Crea, envía y firma en tres pasos.',
  'how.step1Title': 'Crea una plantilla',
  'how.step1Desc': 'Extrae o sube PDF, editor de texto (crea desde cero o pega y edita), campos de firma (fecha, nombre, términos, bloques de firma), diseño personalizado. Guarda como plantilla y reutiliza.',
  'how.step2Title': 'Envía a los destinatarios',
  'how.step2Desc': 'Envía documentos por correo con enlaces de firma únicos y seguros. Añade varios destinatarios, copia enlaces para compartir o haz seguimiento de aperturas y firmas.',
  'how.step3Title': 'Recibe los PDF firmados',
  'how.step3Desc': 'Recibe PDFs firmados verificados con registro de auditoría: fecha, correo, teléfono y consentimiento. Recibe un correo de confirmación cuando se complete la firma.',
  'pricing.compareHeadline': '¿Por qué pagar 19 $/mes por firmas electrónicas?',
  'pricing.comparePlatform': 'Plataforma',
  'pricing.comparePrice': 'Precio',
  'pricing.compareUs': 'Prime Document Sign',
  'pricing.compareDocuSign': 'DocuSign',
  'pricing.compareDropboxSign': 'Dropbox Sign',
  'pricing.comparePandaDoc': 'PandaDoc',
  'pricing.comparePerMonth': '{price}/mes',
  'pricing.compareBestValue': 'Mejor valor',
  'pricing.compareWhyPayLine1': 'Envía firmas electrónicas legalmente vinculantes en segundos',
  'pricing.compareWhyPayLine2': '¿Más de un envío? Suscripciones desde 2 $ al mes',
  'pricing.compareBenefitSingle': 'Envía documentos sueltos',
  'pricing.compareBenefitNoContract': 'Sin contratos caros',
  'pricing.compareBenefitPayWhenNeed': 'Paga solo cuando lo necesites',
  'pricing.compareBenefitTemplates': 'Elige entre más de 30 plantillas',
  'pricing.compareDisclaimer': 'Precios de competencia según planes de inicio públicos; pueden variar.',
  'trust.secureLinks': 'Enlaces de firma únicos y seguros para cada documento',
  'trust.auditTrail': 'Registro de auditoría completo en cada firma (quién, cuándo, IP)',
  'trust.verifiablePdfs': 'PDFs firmados verificables que puedes conservar',
  'trust.footer': 'Con la confianza de freelancers y pequeñas empresas en todo el mundo',
  'useCases.title': 'Perfecto para ( Plantillas listas )',
  'useCases.freelancers': 'Freelancers que envían contratos',
  'useCases.agencies': 'Agencias que firman acuerdos',
  'useCases.landlords': 'Arrendadores que envían contratos de alquiler',
  'useCases.startups': 'Startups que firman NDA',
  'useCases.carBoat': 'Vender coche o barco con documento legal',
  'useCases.consultants': 'Consultores e independientes',
  'useCases.equipmentRental': 'Alquilar equipos con un acuerdo formal',
  'useCases.contractors': 'Contratistas independientes que formalizan trabajos',
  'useCases.website': 'Acuerdos de proyectos web y digitales',
  'pricing.title': 'Precios',
  'pricing.billAnnually': 'Facturación anual',
  'pricing.billMonthly': 'Facturación mensual',
  'pricing.getStarted': 'Comenzar',
  'pricing.mostPopular': 'MÁS POPULAR',
  'pricing.billedPerYear': '${amount}/año',
  'pricing.perMonth': '/mes',
  'pricing.tierBasic': 'Básico',
  'pricing.tierStandard': 'Estándar',
  'pricing.tierPremium': 'Premium',
  'pricing.descBasic': 'Para uso ocasional.',
  'pricing.descStandard': 'Para equipos en crecimiento.',
  'pricing.descPremium': 'Para usuarios avanzados.',
  'about.label': 'Por qué elegirnos',
  'about.title': 'Nosotros',
  'about.subtitle': 'Hacemos que los flujos de firma sean simples, rápidos y seguros para que te enfoques en tu negocio.',
  'about.speed': 'Velocidad',
  'about.builtForSpeed': 'Diseñado para la velocidad',
  'about.builtForSpeedDesc': 'Nuestra interfaz moderna te permite crear y enviar documentos en minutos. Los firmantes pueden completar acuerdos desde cualquier dispositivo.',
  'about.security': 'Seguridad',
  'about.dataSecurity': 'Seguridad de datos',
  'about.dataSecurityTitle': 'Alojado en Google Firebase y Google Cloud',
  'about.dataSecurityDesc': 'Los datos de tu cuenta, documentos, plantillas y actividad de firma se procesan en Google Firebase y Google Cloud, plataformas pensadas para aplicaciones en producción que requieren autenticación y almacenamiento robustos. El tráfico usa HTTPS (TLS) de extremo a extremo; los datos en reposo se cifran con claves gestionadas por Google (incluido AES-256). Los inicios de sesión usan Firebase Authentication y las reglas de seguridad de Firestore ayudan a que las lecturas y escrituras correspondan a tu cuenta, de modo que tu espacio de trabajo quede aislado y no sea legible para todo Internet. La infraestructura se ejecuta en la red global de Google con prácticas de monitorización, parches y durabilidad descritas en la documentación de Google, y no vendemos tus datos personales ni el contenido de tus documentos a intermediarios ni anunciantes. Para subprocesadores, programas de cumplimiento y tus derechos, consulta nuestra Política de privacidad.',
  'about.dataSecurityPrivacyCta': 'Leer la Política de privacidad completa →',
  'about.privacyPill': 'Privacidad',
  'about.privacyFocused': 'Enfocado en la privacidad',
  'about.privacyFocusedDesc': 'Cada enlace de firma es único: los destinatarios solo ven lo que les envías. Los PDF firmados incluyen un registro de auditoría claro que puedes archivar: quién firmó, cuándo y el consentimiento prestado, para que privacidad y prueba vayan juntos.',
  'about.teams': 'Personas y equipos',
  'about.madeForTeams': 'Para personas y equipos',
  'about.madeForTeamsDesc': 'Tanto si firmas solo como en equipo, nuestras plantillas lo facilitan. Crea documentos con texto, encabezados y listas. Añade campos de firma, fecha, nombre y campos personalizados. Guarda plantillas y envíalas a varios destinatarios.',
  'about.sectionHeadlineBefore': 'Diseñado para la ',
  'about.sectionHeadlineAccent': 'confianza y la velocidad',
  'about.firebaseVisualBadge': 'Google Firebase · Google Cloud',
  'faq.title': 'Preguntas frecuentes',
  'faq.searchHint': 'Busca por palabra(s) clave para encontrar FAQs rápidamente',
  'faq.searchPlaceholder': 'ej. PDF, plantilla, firma...',
  'faq.noResults': 'Ninguna FAQ coincide con tu búsqueda. Prueba otras palabras.',
  'faq.more': 'Más',
  'faq.less': 'Menos',
  'faq.eyebrow': '¿Tienes dudas?',
  'faq.titleBefore': 'Preguntas ',
  'faq.titleAccent': 'frecuentes',
  'faq.subtitleLead': 'Todo lo que necesitas saber sobre Prime Document Sign. ¿No encuentras la respuesta? ',
  'faq.subtitleLink': 'Escríbenos.',
  'faq.clearSearchAria': 'Borrar búsqueda',
  'faq.subscriptionsWorkQ': '¿Cómo funcionan las suscripciones?',
  'faq.subscriptionsWorkA': 'Ofrecemos un plan Premium ({{monthly}} $/mes o {{annual}} $/año). También puedes pagar por envío con la opción única ({{oneTimePrice}} $ por envío). Crea y previsualiza documentos gratis; paga al enviar. Las suscripciones se facturan mensual o anualmente vía Stripe. Gestiona tu plan en Mi cuenta → Mi suscripción.',
  'faq.upgradePlanQ': '¿Cómo actualizo mi plan?',
  'faq.upgradePlanA': 'Ve a Mi cuenta → Mi suscripción, elige un plan superior (p. ej. Estándar o Premium) y confirma. La actualización suele aplicarse de inmediato. Puede cobrarse un prorrateo por el resto del periodo. Los nuevos límites (correos, plantillas, adjuntos) se aplican al instante.',
  'faq.downgradePlanQ': '¿Cómo bajo de plan?',
  'faq.downgradePlanA': 'Ve a Mi cuenta → Mi suscripción, elige un plan inferior y confirma. El cambio se aplica al inicio del siguiente ciclo. Hasta entonces mantienes tu plan actual. No hay reembolsos por la diferencia. Tras el cambio, los límites se reducen al nuevo plan.',
  'faq.cancelPlanQ': '¿Cómo cancelo mi suscripción?',
  'faq.cancelPlanA': 'Ve a Mi cuenta → Mi suscripción y cancela desde el portal de Stripe o contacta a soporte. La cancelación se aplica al final del periodo de facturación. Conservas el acceso hasta entonces. No hay reembolsos prorrateados. Después termina el acceso y puedes volver a suscribirte cuando quieras.',
  'faq.oneTimeOptionQ': '¿Qué es la opción de pago por envío?',
  'faq.oneTimeOptionA': 'Si solo necesitas enviar de vez en cuando, puedes pagar {{oneTimePrice}} $ por envío en lugar de suscribirte. Tienes todas las funciones Premium (plantillas, adjuntos, registro) para ese envío. Paga de nuevo por cada envío extra. Elige esta opción al registrarte o añade envíos desde Mi suscripción cuando llegues al límite.',
  'faq.emailLimitQ': '¿Qué pasa si alcanzo el límite de correos al mes?',
  'faq.emailLimitA': 'Básico permite 5 correos/mes, Estándar 50, Premium 150. Cada destinatario cuenta como un correo. Los límites se reinician al inicio de cada mes. Al llegar al límite puedes comprar más correos o subir de plan. Los de pago único pagan {{oneTimePrice}} $ por cada envío adicional.',
  'faq.yearlyBillingQ': '¿Hay facturación anual?',
  'faq.yearlyBillingA': 'Sí. Premium ofrece facturación mensual o anual: {{monthly}} $/mes o {{annual}} $/año. La anual ahorra hasta {{discountPercent}}% respecto a la mensual. Elige al registrarte o cambia en Mi suscripción.',
  'faq.multipleRecipientsQ': '¿Puedo enviar a varios destinatarios?',
  'faq.multipleRecipientsA': 'Sí. Básico permite hasta 5 destinatarios por envío; Estándar y Premium hasta 10. Introduce los correos separados por comas. Cada uno recibe un enlace único y puede completar el documento sin cuenta.',
  'faq.reuseTemplatesQ': '¿Puedo reutilizar plantillas?',
  'faq.reuseTemplatesA': 'Básico incluye 3 plantillas guardadas, Estándar 10, Premium 25. Usa Historial de plantillas (Mi cuenta) para cargarlas cuando quieras. Las plantillas guardan contenido, formato y campos de firma.',
  'faq.recipientAccountQ': '¿El destinatario necesita cuenta?',
  'faq.recipientAccountA': 'No. Recibe el correo con el enlace y puede firmar desde su dispositivo. No hace falta cuenta. Funciona en escritorio, tablet y móvil.',
  'faq.confirmationEmailQ': '¿Recibiré un correo de confirmación?',
  'faq.confirmationEmailA': 'Sí. Cuando se complete el documento, recibirás un correo con el PDF firmado adjunto. Cada PDF incluye registro de auditoría: fecha, correo, teléfono y consentimiento.',
  'faq.previewPdfQ': '¿Puedo previsualizar el PDF antes de enviar?',
  'faq.previewPdfA': 'Sí. Usa el botón Vista previa PDF para ver el diseño exacto. Revisa formato y contenido y luego envía o copia el enlace.',
  'faq.editAgreementQ': '¿Puedo editar el texto del acuerdo?',
  'faq.editAgreementA': 'Sí. Usa el editor de texto para añadir títulos, listas, negrita, cursiva, subrayado y tamaños. También puedes subir un PDF para extraer texto o mostrarlo con tu acuerdo debajo.',
  'faq.signatureRequiredQ': '¿Es obligatoria la firma para enviar?',
  'faq.signatureRequiredA': 'Sí. Los destinatarios deben completar fecha, nombre completo, casilla de términos y firma antes de enviar. Así cada documento cumple los requisitos de validez legal.',
  'faq.attachmentsQ': '¿Cuántos adjuntos puedo incluir?',
  'faq.attachmentsA': 'Básico no incluye adjuntos. Estándar permite hasta 3 adjuntos por correo (8 MB en total). Premium hasta 10 adjuntos por correo (8 MB en total). Se envían con el enlace de firma.',
  'faq.emailActivityQ': '¿Qué es Actividad de correo y límites (Premium)?',
  'faq.emailActivityA': 'Premium incluye Actividad de correo y límites. Ábrelo desde Mi cuenta para ver todo el envío de correos: qué documentos, cuándo y a quién. Útil para cumplimiento y registros.',
  'faq.emailRemindersQ': '¿Cómo funcionan los recordatorios por correo?',
  'faq.emailRemindersA': 'En el creador de documentos, paso 4 (Funciones adicionales), puedes activar recordatorios a 1, 3 y/o 7 días por envío. Tras el primer correo de firma, solo enviamos un recordatorio si ese destinatario aún no ha completado el documento. Los recordatorios se detienen automáticamente al firmar. Los correos de recordatorio aparecen en Actividad de correo con fecha y hora; no cuentan para tu límite mensual de envíos.',
  'faq.defaultSenderQ': '¿Puedo definir un correo de envío por defecto?',
  'faq.defaultSenderA': 'Sí. Ve a Mi cuenta → Datos de la cuenta, introduce tu correo en el campo Correo por defecto y guarda. Se rellenará automáticamente al enviar documentos.',
  'faq.mobileSignQ': '¿Pueden firmar en móvil?',
  'faq.mobileSignA': 'Sí. La experiencia de firma es responsive. Pueden abrir el enlace en smartphone o tablet, dibujar la firma con el dedo o un stylus y completar el formulario desde cualquier dispositivo.',
  'faq.getHelpQ': '¿Cómo obtengo ayuda?',
  'faq.getHelpA': 'Usa Soporte en Mi cuenta o el formulario de contacto de la web. Respondemos lo antes posible.',
  'faq.dataSecureQ': '¿Mis datos están seguros?',
  'faq.dataSecureA': 'Sí. Usamos prácticas estándar para proteger tus documentos e información. Se transmiten y almacenan de forma segura.',
  'faq.fileFormatsQ': '¿Qué formatos de archivo se admiten?',
  'faq.fileFormatsA': 'Los documentos se crean en nuestro editor de texto. Los acuerdos completados se generan como PDF, compatibles para uso legal y empresarial.',
  'faq.deleteTemplateQ': '¿Qué pasa si borro una plantilla?',
  'faq.deleteTemplateA': 'Las plantillas borradas se eliminan de forma permanente. Asegúrate de no necesitarla antes de borrar. Puedes crear una nueva desde tu documento actual cuando quieras.',
  'faq.ownLogoQ': '¿Puedo añadir mi logo?',
  'faq.ownLogoA': 'Sí, en planes Estándar y Premium. Sube tu logo (hasta 20 KB) y elige su posición. Aparece en la página de firma y en el PDF firmado. Básico no incluye esta función.',
  'faq.uploadPdfQ': '¿Cómo subo un PDF?',
  'faq.uploadPdfA': 'En el creador de documentos, usa la opción Subir PDF (planes Estándar y Premium). Tu PDF se muestra encima o junto al texto del acuerdo. Los destinatarios ven el documento completo al firmar.',
  'faq.extractPdfQ': '¿Qué es la extracción de PDF y cómo funciona?',
  'faq.extractPdfA': 'La extracción de PDF (Estándar y Premium) permite extraer texto de un PDF existente al editor para editarlo. Sube tu PDF, elige Extraer texto, y el contenido se copia. Luego puedes modificarlo y añadir campos de firma.',
  'faq.richTextEditorQ': '¿Qué puedo hacer con el editor de texto enriquecido?',
  'faq.richTextEditorA': 'El editor permite crear y formatear acuerdos: títulos, negrita, cursiva, listas, tamaños de fuente. Añade bloques de firma debajo. Todo con clics, sin código.',
  'faq.previewWhenQ': '¿Cuándo debo previsualizar antes de enviar?',
  'faq.previewWhenA': 'Usa siempre Vista previa PDF antes de enviar. Muestra el diseño exacto: texto, bloques de firma, fecha, nombre. Revisa el formato y luego envía o copia el enlace.',
  'faq.documentLifetimeQ': '¿Cuánto duran los enlaces de firma? ¿Puedo pedir una extensión?',
  'faq.documentLifetimeA': 'Los enlaces suelen estar activos unos 30 días. Descarga y guarda tu PDF firmado antes de que expire. Si un enlace ha expirado, contacta al remitente para pedir un nuevo correo con un enlace fresco.',
  'faq.editLayoutQ': '¿Cómo edito el diseño de la firma?',
  'faq.editLayoutA': 'Usa Editar diseño en la sección de firma para reorganizar campos. Arrastra fecha, nombre, condiciones, bloques de firma y campos personalizados. Añade espaciadores y elige el número de columnas.',
  'faq.customFieldsQ': '¿Cómo añado campos personalizados (texto, fecha, casilla, etc.)?',
  'faq.customFieldsA': 'Haz clic en Añadir campo personalizado. Elige etiqueta y tipo: Texto, Número, Fecha, Hora, Lista, Casilla o Firma. Hasta 10 campos por documento. Indica qué firmantes ven cada campo y usa Editar diseño.',
  'faq.multipleSignaturesQ': '¿Puedo añadir 2 o más firmas (varios firmantes)?',
  'faq.multipleSignaturesA': 'Sí. Usa la sección Destinatarios para añadir un segundo firmante. Cada uno recibe un enlace único y su propio bloque de firma. Básico: hasta 5; Estándar y Premium: hasta 10 destinatarios por envío.',
  'faq.documentBuilderTipsQ': '¿Qué puedo hacer en el creador de documentos?',
  'faq.documentBuilderTipsA': 'Crear acuerdos, subir o extraer PDFs, añadir bloques de firma, campos personalizados y adjuntos. Editar diseño, guardar plantillas, previsualizar. Los cambios se guardan automáticamente.',
  'faq.clearEverythingQ': '¿Qué hace Borrar todo?',
  'faq.clearEverythingA': 'Borrar todo reinicia el creador: texto, bloques de firma, campos personalizados y adjuntos. Úsalo para empezar de cero. Tus plantillas guardadas no se ven afectadas.',
  'faq.forgotPasswordQ': 'Olvidé mi contraseña. ¿Cómo la restablezco?',
  'faq.forgotPasswordA': 'En la pantalla de inicio de sesión, haz clic en ¿Olvidaste tu contraseña? Introduce tu correo y envía el enlace. Revisa tu bandeja (y spam). El enlace caduca—solicita uno nuevo si hace falta. Inicia sesión con la nueva contraseña.',
  'faq.saveTemplateQ': '¿Cómo guardo un documento como plantilla?',
  'faq.saveTemplateA': 'Crea tu documento y haz clic en Guardar plantilla. Ponle un nombre y Guardar como nuevo. Aparece en Historial de plantillas (Mi cuenta). Para actualizar: carga la plantilla, modifica y Guardar plantilla → Actualizar plantilla.',
  'faq.loadTemplateQ': '¿Cómo cargo una plantilla del historial?',
  'faq.loadTemplateA': 'Ve a Mi cuenta → Historial de plantillas. Haz clic en la que quieras. Se abre en el creador con todo el contenido y diseño. Edita si hace falta, añade destinatarios y envía.',
  'faq.templateLimitsQ': '¿Cuántas plantillas puedo guardar?',
  'faq.templateLimitsA': 'Básico: 3, Estándar: 10, Premium: 25 plantillas. Cada una guarda texto, formato, bloques de firma y diseño. Al llegar al límite: borra una antigua o mejora tu plan.',
  'faq.recipientNoEmailQ': '¿El destinatario no recibió el correo de firma?',
  'faq.recipientNoEmailA': 'Pídele que revise el spam. Usa Copiar enlace para obtener la URL y compártela manualmente (mensaje, Slack, etc.). O reenvía el documento al mismo correo para un enlace nuevo.',
  'faq.editAfterSendQ': '¿Puedo editar un documento después de enviarlo?',
  'faq.editAfterSendA': 'No. Una vez enviado, el contenido queda bloqueado. Para cambiar: crea un nuevo documento con los cambios y envíalo de nuevo. Los borradores no enviados se pueden editar libremente.',
  'faq.changeAccountQ': '¿Cómo cambio mi correo o contraseña?',
  'faq.changeAccountA': 'Mi cuenta → Detalles de la cuenta. Actualiza correo o contraseña. Para contraseña: introduce la actual y la nueva. Usa ¿Olvidaste tu contraseña? si no la recuerdas.',
  'faq.browserSupportQ': '¿Qué navegadores y dispositivos se admiten?',
  'faq.browserSupportA': 'Chrome, Firefox, Safari, Edge (escritorio y móvil). Firma responsive en smartphones y tablets. Usa versiones recientes. No hace falta descargar app.',
  'faq.copyLinkQ': '¿Cómo copio un enlace para compartir en lugar de enviar por correo?',
  'faq.copyLinkA': 'Tras crear el documento, haz clic en Copiar enlace. La URL se copia. Pégalo en un mensaje, correo o Slack. El destinatario puede firmar sin recibir correo nuestro.',
  'faq.resendDocumentQ': '¿Puedo reenviar un documento si el destinatario no ha firmado?',
  'faq.resendDocumentA': 'Sí. Envía de nuevo el mismo documento al mismo u otro correo. Cada envío crea un enlace nuevo. Si el original expiró, reenviar da un enlace fresco. Usa Actividad de correo (Premium) para seguir los envíos.',
  'testimonials.eyebrow': 'TESTIMONIOS',
  'testimonials.title': 'Lo que dicen nuestros clientes.',
  'testimonials.quote1': 'El precio es el más bajo. Comparé varias herramientas y Prime Document Sign ofrece la mejor relación calidad-precio y es muy fácil de usar.',
  'testimonials.quote2': 'Copié y pegué un acuerdo de ChatGPT, lo edité en minutos y lo envié para firma. Listo en menos de 10 minutos.',
  'testimonials.quote3': 'Lo hice todo desde el móvil: creé el documento, añadí los campos de firma y lo envié yendo al trabajo. Muy práctico.',
  'testimonials.quote4': 'Fácil de usar y el precio es justo. Sin costes ocultos. Mi equipo lo usa para contratos y NDAs; todos lo aprendieron rápido.',
  'testimonials.quote5': 'Pegué el texto del contrato, coloqué los bloques de firma y envié. Los destinatarios firmaron el mismo día. Justo lo que necesitaba.',
  'testimonials.quote6': 'Lo usé en el portátil y en el móvil. La experiencia es fluida en ambos. La mejor opción de firma electrónica que he encontrado.',
  'testimonials.prev': 'Anterior',
  'testimonials.next': 'Siguiente',
  'contact.title': 'Contáctanos',
  'contact.subtitle': '¿Tienes preguntas? Nos encantaría saber de ti.',
  'contact.eyebrow': 'Ponte en contacto',
  'contact.headlineBefore': 'Hablemos ',
  'contact.headlineAccent': 'con nosotros',
  'contact.responseTimeLabel': 'Tiempo de respuesta',
  'contact.responseTimeValue': 'En menos de 24 horas',
  'contact.secureLabel': 'Seguro y privado',
  'contact.secureValue': 'Cifrado AES-256',
  'contact.trustNoSpam': 'Sin spam, nunca',
  'contact.trustHumanSupport': 'Atención humana real',
  'contact.firstName': 'Nombre',
  'contact.lastName': 'Apellidos',
  'contact.email': 'Correo electrónico',
  'contact.message': 'Mensaje',
  'contact.sendMessage': 'Enviar mensaje',
  'contact.required': '*',
  'contact.placeholderFirst': 'Introduce tu nombre',
  'contact.placeholderLast': 'Introduce tus apellidos',
  'contact.placeholderEmail': 'Introduce tu correo',
  'contact.placeholderMessage': 'Cuéntanos en qué podemos ayudarte...',
  'contact.attachments': 'Adjuntos',
  'contact.attachmentsHint': 'Hasta 5 archivos, 2 MB en total',
  'contact.addFiles': '+ Añadir archivos',
  'contact.addAttachmentsAria': 'Añadir adjuntos',
  'contact.location': 'Ubicación (país o región)',
  'contact.locationPlaceholder': 'ej. España, México, Argentina',
  'contact.subscription': 'Estado de suscripción',
  'contact.subscriptionSubscribed': 'Suscrito',
  'contact.subscriptionNotSubscribed': 'No suscrito',
  'contact.subscriptionPreferNot': 'Prefiero no decir',
  'contact.phone': 'Teléfono (opcional)',
  'contact.phonePlaceholder': 'ej. +34 612 345 678',
  'contact.company': 'Empresa u organización (opcional)',
  'contact.companyPlaceholder': 'Nombre de la empresa',
  'auth.forgotPassword': '¿Olvidaste tu contraseña?',
  'auth.backToLogIn': 'Volver a iniciar sesión',
  'auth.sendResetLink': 'Enviar enlace de restablecimiento',
  'auth.checkEmailReset': 'Revisa tu correo para el enlace de restablecimiento.',
  'auth.emailLabel': 'Correo',
  'auth.passwordLabel': 'Contraseña',
  'auth.firstNameLabel': 'Nombre',
  'auth.lastNameLabel': 'Apellidos',
  'auth.enterEmail': 'Introduce tu correo.',
  'auth.enterEmailPassword': 'Introduce correo y contraseña.',
  'auth.passwordMinLength': 'La contraseña debe tener al menos 8 caracteres.',
  'auth.passwordSpecial': 'La contraseña debe incluir un carácter especial.',
  'auth.passwordsNoMatch': 'Las contraseñas no coinciden.',
  'auth.signInWithGoogle': 'Iniciar sesión con Google',
  'auth.or': 'o',
  'auth.logInFailed': 'Error al iniciar sesión.',
  'auth.signUpFailed': 'Error al registrarse.',
  'auth.emailAlreadyInUse': 'Este correo ya está en uso.',
  'connectionError.message': 'Problema de conexión. Compruebe su conexión a internet y actualice la página.',
  'connectionError.refresh': 'Actualizar página',
  'connectionError.tooManyRequests': 'Demasiados intentos. Inténtelo de nuevo más tarde.',
  'auth.emailPlaceholder': 'correo@ejemplo.com',
  'auth.passwordPlaceholder': 'Introduce tu contraseña',
  'auth.firstNamePlaceholder': 'Juan',
  'auth.lastNamePlaceholder': 'García',
  'auth.manageSubscription': 'Gestionar suscripción',
  'auth.subscribe': 'Suscribirse',
  'auth.signUpForSubscription': 'Registrarse para suscripción',
  'auth.currentPlan': 'PLAN ACTUAL',
  'auth.updatePlanHint': 'Actualiza tu plan en Stripe para obtener más créditos mensuales.',
  'auth.updatePlanStripe': 'Actualiza tu plan, método de pago o cancela en el portal seguro de Stripe.',
  'auth.subscribeToPlan': 'Suscríbete a un plan para comenzar.',
  'auth.topUpCredits': 'Comprar más créditos ({{label}}: {{price}} $)',
  'pricing.featureRecipients5': 'Hasta 5 destinatarios por envío',
  'pricing.featureRecipients10': 'Hasta 10 destinatarios por envío',
  'pricing.featureEmails5': 'Máx. 5 correos al mes',
  'pricing.featureEmails50': 'Máx. 50 correos al mes',
  'pricing.featureEmails150': 'Máx. 150 correos al mes',
  'pricing.featureTemplates3': '3 plantillas guardadas',
  'pricing.featureTemplates10': '10 plantillas guardadas',
  'pricing.featureTemplates25': '25 plantillas guardadas',
  'pricing.featureChars3k': 'Límite 3.000 caracteres',
  'pricing.featureChars20k': 'Límite 20.000 caracteres',
  'pricing.featureChars30k': 'Límite 30.000 caracteres',
  'pricing.featureAttachmentsNone': 'Sin adjuntos adicionales',
  'pricing.featureAttachments3': '3 adjuntos (8 MB total)',
  'pricing.featureAttachments10': '10 adjuntos (8 MB total)',
  'pricing.featurePdfUpload': 'Subida de PDF completa',
  'pricing.featureAuditTrail': 'Registro de auditoría completo',
  'pricing.featurePdfExtract': 'Extracción y edición de texto PDF',
  'pricing.featureCustomFields': 'Crear campos personalizados y editar diseño',
  'pricing.featureCopyLink': 'Copiar enlace para firmar',
  'pricing.featureLogo': 'Subir logo personalizado',
  'pricing.featureVerification': 'Verificación del destinatario',
  'app.createYourDocument': 'Crea tu documento',
  'app.backToApp': 'Volver a la app',
  'app.backToMainSite': 'Volver al sitio',
  'app.backShort': 'Volver',
  'app.myAccount': 'Mi cuenta',
  'app.saveTemplate': 'Guardar plantilla',
  'app.templatesUsed': 'Plantillas usadas',
  'app.templatesUsedSaved': '{{count}} plantillas guardadas',
  'app.startFromTemplate': 'Empezar desde plantilla',
  'app.startFromTemplateHint': 'Elige una plantilla para rellenar el documento. Puedes editarla después de seleccionar.',
  'app.signedInAs': 'Conectado como',
  'app.sendCredits': 'Créditos de envío',
  'app.freeSendBanner': 'Tienes 1 envío de correo gratis — úsalo para enviar tu documento para firma. Suscríbete cuando quieras para más.',
  'app.creditEqualsSend': '1 crédito = 1 envío por email',
  'app.topUpCredits': 'Créditos extra',
  'app.emailSends': 'envíos por email',
  'app.signedAgreements': 'acuerdos firmados',
  'app.usedAfterAllowance': '(usados tras la cuota mensual)',
  'app.sendForSignature': 'Enviar para firma',
  'app.recipientsSection': 'Enviar a',
  'app.fromNameOrg': 'Nombre / Organización',
  'app.fromNamePlaceholder': 'Tu nombre o organización',
  'app.fromEmail': 'Email del remitente',
  'app.fromEmailPlaceholder': 'Dirección de email',
  'app.recipientEmail': 'Email del destinatario',
  'app.recipientHint': 'Separados por comas, hasta {{max}} destinatario(s)',
  'app.recipientPlaceholder': 'Email del destinatario',
  'app.recipientTooltip': 'Ejemplo: a@b.com, c@d.com, e@f.com',
  'app.previewPdf': 'Vista previa PDF',
  'app.clearEverything': 'Borrar todo',
  'app.clearEverythingTitle': 'Borrar documento, destinatarios y borrador guardado',
  'app.copyLink': 'Copiar enlace',
  'app.copyLinkSubscribersOnly': 'Copiar enlace (solo suscriptores)',
  'app.generatingLink': 'Generando enlace…',
  'app.sendEmail': 'Enviar email',
  'app.agreementText': 'Texto del acuerdo',
  'app.uploadPdfExtract': 'Subir PDF para extraer texto',
  'app.fullPdfUpload': 'Subir PDF completo',
  'app.agreementPlaceholder': 'Haz clic aquí para empezar y escribir el texto del acuerdo...',
  'app.attachments': 'Adjuntos',
  'app.attachmentsHint': 'Hasta 10 archivos, máx. 8 MB en total.',
  'app.addAttachment': '+ Añadir adjunto',
  'app.signatureSection': 'Sección de firma',
  'app.totalSignatures': 'Total de firmas',
  'app.createNewField': 'Crear nuevo campo',
  'app.addField': 'Añadir campo',
  'app.layout': 'Diseño',
  'app.editLayout': 'Editar diseño',
  'app.addFieldTooltip': 'Añade un campo (texto, fecha, casilla o firma). El campo aparecerá en el diseño y se puede reordenar o eliminar. Máximo {{max}} campos.',
  'app.date': 'Fecha',
  'app.datePlaceholder': 'aaaa/mm/dd',
  'app.termsConditions': 'Términos y condiciones',
  'app.fullName': 'Nombre completo',
  'app.fullNamePlaceholder': 'Nombre legal completo',
  'app.signature': 'Firma',
  'app.clickToSign': 'Clic para firmar',
  'app.termsAgree': 'Acepto todos los términos y condiciones.',
  'app.phone': 'Teléfono',
  'app.phonePlaceholder': 'Introduce el número de teléfono',
  'app.enterFieldPlaceholder': 'Introduce {{label}}',
  'app.enterNumber': 'Introduce el número',
  'app.selectOption': 'Seleccionar...',
  'app.noFields': 'Sin campos',
  'app.newDocument': 'Nuevo documento',
  'app.templateLabel': 'Plantilla: {{name}}',
  'app.forSubscribersOnly': 'Solo para suscriptores',
  'app.emailCredits': 'Créditos de email',
  'app.creditHintDeliver': '1 crédito = 1 envío — haz clic en Enviar para enviar',
  'app.skipAuthTesting': 'Omitir auth (pruebas)',
  'app.agreementRequired': 'Se requiere texto del acuerdo o PDF.',
  'app.agreementOrPdfRequired': 'Se requiere texto del acuerdo o un PDF.',
  'app.loadingPdf': 'Cargando PDF…',
  'app.clearConfirmTitle': 'Borrar todo',
  'app.clearConfirmMessage': '¿Seguro que quieres borrar todos los campos y adjuntos?',
  'app.cancel': 'Cancelar',
  'app.clear': 'Borrar',
  'app.clearConfirmButton': 'Sí, borrar todo',
  'footer.tagline': 'Firma electrónica segura para usuarios modernos.',
  'footer.product': 'Producto',
  'footer.templates': 'Plantillas',
  'footer.company': 'Empresa',
  'footer.contactSupport': 'Soporte',
  'footer.copyright': '© 2026 primedocumentsign. Todos los derechos reservados.',
  'footer.terms': 'Términos de servicio',
  'footer.privacy': 'Política de privacidad',
  'auth.logIn': 'Iniciar sesión',
  'auth.loggingIn': 'Iniciando sesión…',
  'auth.getStarted': 'Comenzar',
  'auth.signUp': 'Registrarse',
  'auth.logInToManage': 'Inicia sesión para gestionar y enviar documentos para firma.',
  'auth.startSending': 'Comienza a enviar documentos con un plan simple.',
  'auth.termsConfirmStart': 'Confirmo que he leído y acepto los',
  'auth.termsConfirmEnd': '.',
  'auth.termsMustAccept': 'Acepte los Términos de servicio para crear su cuenta.',
  'email.signSubject': 'Por favor firme este acuerdo',
  'email.signTitle': 'Documento para firmar',
  'email.signSubtitle': 'Se le ha solicitado firmar un documento',
  'email.fromLabel': 'De',
  'email.signBody': 'Haga clic en el botón para abrir el documento y añadir su firma. Cualquier destinatario puede usar este enlace para acceder y firmar; no se requiere cuenta ni suscripción.',
  'email.signButton': 'Firmar documento',
  'email.copyLink': 'O copie este enlace:',
  'email.ignoreNote': 'Si no esperaba este correo, puede ignorarlo.',
  'modal.editFieldLayout': 'Editar diseño de campos',
  'modal.editFieldLayoutHint': 'Arrastra los campos para reordenar o mover entre columnas.',
  'modal.columns': 'Columnas',
  'modal.col': '{{n}} col',
  'modal.addSpace': 'Añadir espacio',
  'modal.fields': 'Campos',
  'modal.leftColumn': 'Columna izquierda',
  'modal.rightColumn': 'Columna derecha',
  'modal.removeFromLayout': '¿Quitar {{name}} del diseño?',
  'modal.space': 'espacio',
  'modal.yesRemove': 'Sí, quitar',
  'modal.keepIt': 'Mantener',
  'modal.emptySpace': 'Espacio vacío',
  'modal.dropFieldsHere': 'Suelta campos aquí',
  'modal.removedFromLayout': 'Quitados del diseño — haz clic en + para restaurar',
  'modal.saveLayout': 'Guardar diseño',
  'modal.removeFromLayoutTitle': 'Quitar del diseño',
  'modal.restoreToLayout': 'Restaurar al diseño',
  'modal.editCustomField': 'Editar campo personalizado',
  'modal.editCustomFieldHint': 'Cambia la etiqueta, el tipo o qué firmantes ven este campo.',
  'modal.addCustomField': 'Añadir campo personalizado',
  'modal.addCustomFieldHint': 'Crea un nuevo campo para el formulario de firma. Máx. 10 campos.',
  'modal.fieldLabel': 'Etiqueta del campo',
  'modal.fieldLabelPlaceholder': 'ej. Nombre de la empresa',
  'modal.fieldType': 'Tipo de campo',
  'modal.displayContent': 'Contenido (solo lectura para el destinatario, máx. 100 caracteres)',
  'modal.displayContentPlaceholder': 'ej. Revisa los términos siguientes',
  'modal.picklistOptions': 'Opciones de lista (máx. 10)',
  'modal.typeAndPressAdd': 'Escribe y pulsa Añadir',
  'modal.add': 'Añadir',
  'modal.addedToSignature': 'Añadido a firma',
  'modal.addedToSignatureHint': 'Marca las casillas para añadir el campo al diseño de firma.',
  'modal.signature1': 'Firma 1',
  'modal.signature2': 'Firma 2',
  'modal.close': 'Cerrar',
  'modal.save': 'Guardar',
  'modal.fieldLabelRequired': 'La etiqueta del campo es obligatoria',
  'modal.displayContentRequired': 'El contenido es obligatorio para Texto',
  'modal.picklistOptionRequired': 'Añade al menos una opción',
  'modal.selectOneSignature': 'Selecciona al menos una firma',
  'modal.signingSectionExceed': 'La sección de firma superaría el límite de {{limit}} KB. Quita contenido primero.',
  'modal.link': 'Enlace',
  'modal.linkTitle': 'Título del enlace',
  'modal.linkUrl': 'URL del enlace',
  'modal.linkTextPlaceholder': 'Texto del enlace',
  'modal.linkUrlPlaceholder': 'https://ejemplo.com',
  'modal.agreementSizeLimitReached': 'Límite de tamaño alcanzado',
  'modal.characterLimitReached': 'Límite de caracteres alcanzado',
  'modal.agreementSizeLimitMessage': 'Has alcanzado el tamaño máximo ({{max}} KB). Quita contenido o imágenes.',
  'modal.characterLimitMessage': 'Has alcanzado el límite de caracteres ({{max}}). Quita texto.',
  'modal.signingSectionLimitReached': 'Límite de sección de firma alcanzado',
  'modal.signingSectionLimitMessage': 'Has alcanzado el tamaño máximo de la sección de firma ({{limit}} KB). Quita campos, firmas o contenido.',
  'modal.ok': 'Aceptar',
  'modal.addYourSignature': 'Añade tu firma',
  'modal.signatureHint': 'Usa el ratón o el trackpad para firmar.',
  'modal.clear': 'Borrar',
  'modal.saveSignature': 'Guardar firma',
  'modal.removeAttachment': 'Quitar adjunto',
  'modal.removeAttachmentConfirm': '¿Quitar "{{name}}" de este documento?',
  'modal.yesRemoveLabel': 'Sí, quitar',
  'modal.removeLogo': 'Quitar logo',
  'modal.removeLogoConfirm': '¿Quitar el logo de este documento?',
  'modal.textDisplay': 'Texto',
  'modal.picklist': 'Lista',
  'modal.number': 'Número',
  'modal.time': 'Hora',
  'modal.editLabel': 'Editar etiqueta',
  'modal.editField': 'Editar campo',
  'modal.text': 'Texto',
  'modal.checkbox': 'Casilla',
  'modal.date': 'Fecha',
  'modal.signature': 'Firma',
  'modal.typeHasDataHint': 'El tipo no se puede cambiar porque este campo ya tiene datos.',
  'modal.typeHasDataTitle': 'El tipo no se puede cambiar cuando el campo tiene datos',
  'modal.noKeepIt': 'No, mantener',
  'modal.yesDelete': 'Sí, eliminar',
  'modal.deleteTemplate': 'Eliminar plantilla',
  'modal.deleteTemplateConfirm': '¿Eliminar "{{name}}"? Esta acción no se puede deshacer.',
  'modal.removeAttachmentFromMessage': '¿Quitar "{{name}}" de tu mensaje?',
  'modal.readyToSend': '¿Enviar ahora?',
  'modal.recipientsLabel': 'Destinatario(s):',
  'modal.readyToSendSubtitle': '¿Has revisado el documento y quieres enviarlo? Los siguientes destinatarios recibirán el correo:',
  'modal.no': 'No',
  'modal.yesSend': 'Sí, enviar',
  'modal.accountAlreadyExists': 'La cuenta ya existe',
  'modal.accountAlreadyExistsMessage': 'Este correo ya está registrado. ¿Quieres iniciar sesión o usar otro correo?',
  'modal.useDifferentEmail': 'Usar otro correo',
  'modal.logIn': 'Iniciar sesión',
  'modal.logOut': '¿Cerrar sesión?',
  'modal.logOutSubtitle': '¿Seguro que quieres cerrar sesión?',
  'modal.yesLogOut': 'Sí, cerrar sesión',
  'lang.es': 'Español',

  'templates.starter.nda.name': 'Acuerdo de confidencialidad (NDA)',
  'templates.starter.nda.scopeTitle': 'Acuerdo de confidencialidad',
  'templates.starter.freelance.name': 'Acuerdo de servicios freelance',
  'templates.starter.freelance.scopeTitle': 'Acuerdo de servicios freelance',
  'templates.starter.vehicle.name': 'Acuerdo de venta de vehículo',
  'templates.starter.vehicle.scopeTitle': 'Acuerdo de venta de vehículo',
  'templates.starter.rental.name': 'Contrato de arrendamiento residencial',
  'templates.starter.rental.scopeTitle': 'Contrato de arrendamiento residencial',
  'templates.starter.recruitment.name': 'Acuerdo de servicios de reclutamiento',
  'templates.starter.recruitment.scopeTitle': 'Acuerdo de servicios de reclutamiento',
  'templates.starter.loan.name': 'Acuerdo de préstamo',
  'templates.starter.loan.scopeTitle': 'Acuerdo de préstamo',
  'templates.starter.website.name': 'Acuerdo de desarrollo de sitios web',
  'templates.starter.website.scopeTitle': 'Acuerdo de desarrollo de sitios web',
  'templates.starter.roommate.name': 'Acuerdo de convivencia',
  'templates.starter.roommate.scopeTitle': 'Acuerdo de convivencia',
  'templates.starter.photography.name': 'Acuerdo de servicios de fotografía',
  'templates.starter.photography.scopeTitle': 'Acuerdo de servicios de fotografía',
  'templates.starter.shortterm-rental.name': 'Acuerdo de alquiler a corto plazo',
  'templates.starter.shortterm-rental.scopeTitle': 'Acuerdo de alquiler a corto plazo',
  'templates.starter.equipment-rental.name': 'Acuerdo de alquiler de equipos',
  'templates.starter.equipment-rental.scopeTitle': 'Acuerdo de alquiler de equipos',
  'templates.starter.independent-contractor.name': 'Acuerdo de contratista independiente',
  'templates.starter.independent-contractor.scopeTitle': 'Acuerdo de contratista independiente',
}
